import React, { useState, useRef, useEffect } from 'react';
import { useLanguageCurrency } from '../context/LanguageCurrencyContext';

const CurrencySelector = () => {
  const { currency, setCurrency } = useLanguageCurrency();
  const [isCurrencyOpen, setIsCurrencyOpen] = useState(false);
  const currencyRef = useRef(null);

  const currencies = [
    { code: 'EGP', name: 'Egyptian Pound', symbol: 'EGP', flag: '🇪🇬' },
    { code: 'USD', name: 'US Dollar', symbol: '$', flag: '🇺🇸' },
    { code: 'EUR', name: 'Euro', symbol: '€', flag: '🇪🇺' },
    { code: 'GBP', name: 'British Pound', symbol: '£', flag: '🇬🇧' },
    { code: 'SAR', name: 'Saudi Riyal', symbol: 'SAR', flag: '🇸🇦' },
    { code: 'AED', name: 'UAE Dirham', symbol: 'AED', flag: '🇦🇪' },
    { code: 'KWD', name: 'Kuwaiti Dinar', symbol: 'KWD', flag: '🇰🇼' },
    { code: 'QAR', name: 'Qatari Riyal', symbol: 'QAR', flag: '🇶🇦' },
  ];

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (currencyRef.current && !currencyRef.current.contains(event.target)) {
        setIsCurrencyOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const currentCurrency = currencies.find(curr => curr.code === currency) || currencies[0];

  return (
    <div className="relative" ref={currencyRef} style={{ width: '100%', zIndex: 10010 }}>
      <button
        onClick={() => setIsCurrencyOpen(!isCurrencyOpen)}
        className="flex items-center justify-center gap-1.5 px-2.5 py-1.5 rounded-lg transition-all duration-200 hover:bg-slate-700/50 w-full"
        style={{
          backgroundColor: isCurrencyOpen ? 'rgba(213, 181, 119, 0.2)' : 'transparent',
          border: '1px solid rgba(213, 181, 119, 0.2)',
          color: 'rgba(255, 255, 255, 0.9)',
          fontSize: '0.7rem',
        }}
        onMouseEnter={(e) => {
          if (!isCurrencyOpen) {
            e.target.style.backgroundColor = 'rgba(213, 181, 119, 0.1)';
          }
        }}
        onMouseLeave={(e) => {
          if (!isCurrencyOpen) {
            e.target.style.backgroundColor = 'transparent';
          }
        }}
      >
        <span className="text-sm">{currentCurrency.flag}</span>
        <span className="hidden sm:inline text-xs font-medium">
          {currentCurrency.symbol}
        </span>
        <svg
          className={`w-3 h-3 transition-transform duration-200 flex-shrink-0 ${isCurrencyOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          style={{ color: 'rgba(255, 255, 255, 0.9)' }}
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isCurrencyOpen && (
        <div
          className="absolute top-full mt-1 max-h-[300px] overflow-y-auto rounded-lg shadow-2xl border"
          style={{
            backgroundColor: 'rgba(29, 42, 59, 0.98)',
            borderColor: 'rgba(213, 181, 119, 0.3)',
            backdropFilter: 'blur(10px)',
            zIndex: 10010,
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            minWidth: '200px',
            width: 'max-content',
            boxSizing: 'border-box'
          }}
        >
          {currencies.map((curr) => (
            <button
              key={curr.code}
              onClick={() => {
                setCurrency(curr.code);
                setIsCurrencyOpen(false);
              }}
              className={`w-full text-left px-3 sm:px-4 py-2.5 sm:py-3 text-sm transition-colors flex items-center gap-2 sm:gap-3 first:rounded-t-lg last:rounded-b-lg ${
                currency === curr.code
                  ? 'text-[#D5B577]'
                  : 'text-gray-300 hover:text-white'
              }`}
              style={{
                backgroundColor: currency === curr.code ? 'rgba(213, 181, 119, 0.1)' : 'transparent',
              }}
              onMouseEnter={(e) => {
                if (currency !== curr.code) {
                  e.target.style.backgroundColor = 'rgba(213, 181, 119, 0.05)';
                }
              }}
              onMouseLeave={(e) => {
                if (currency !== curr.code) {
                  e.target.style.backgroundColor = 'transparent';
                }
              }}
            >
              <span className="text-base sm:text-lg">{curr.flag}</span>
              <div className="flex flex-col">
                <span className="font-medium">{curr.symbol}</span>
                <span className="text-xs text-gray-400">{curr.name}</span>
              </div>
              {currency === curr.code && (
                <svg
                  className="w-4 h-4 ml-auto"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CurrencySelector;
